import { configureStore } from "@reduxjs/toolkit";
import { branchOrderSettingSlice } from "states/branch-order-pickup-setting/order-pickup-setting.slice";
import { branchSlice } from "states/branch/branch.slice";
import { customerAddressSlice } from "states/customer-address/customer-address.slice";
import { globalValueSlice } from "states/global-value/global-value.slice";
import { orderSlice } from "states/order/order.slice";
import { shoppingCartSlice } from "states/shopping-cart/shopping-cart.slice";
export const store = configureStore({
  reducer: {
    shoppingCart: shoppingCartSlice.reducer,
    customerAddress: customerAddressSlice.reducer,
    branch: branchSlice.reducer,
    orderSetting: branchOrderSettingSlice.reducer,
    globalValue: globalValueSlice.reducer,
    order: orderSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),

  devTools: process.env.NODE_ENV === "development",
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
